<template>
  <div class="mapData" :class="{'box-expand': activeProvince === '选择省份'}">
      <div class="option-box">
        <div class="left-option">
          <div class="text">{{activeProvince}}</div>
          <div class="arrow-down" @click="provinceBoxShow = !provinceBoxShow">
            <img src="../assets/headerCount/arrow.png">
          </div>
          <div class="province-box" v-show="provinceBoxShow">
            <div class="province-item" v-for="(item,index) in provinceList" :key="index" :class="activeProvince == item?'checkedItem':''"
                 @click="changeProvince(item)"
            >
              {{item}}
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="right-option">
          <div class="text">{{activeSchool}}</div>
          <div class="arrow-down arrow-left-gap" @click="schoolBoxShow = !schoolBoxShow">
            <img src="../assets/headerCount/arrow.png">
          </div>
          <div class="school-box" v-show="schoolBoxShow">
            <div class="school-item" v-for="(item,index) in schoolList" :key="index" :class="activeSchool==item?'checkedItem':''"
                 @click="changeSchool(item)"
            >
              <el-tooltip class="item" effect="dark" :content="item" placement="top-start" :open-delay="1000">
                <span > {{item}}</span>
              </el-tooltip>

            </div>
          </div>
        </div>
      </div>

    <div ref="cityMap" style="width: 100%;height: 100%;"></div>
  </div>
</template>

<script>
import china from "./china.json";
import {getAlarmTiming, getAssetCorrelationMap, getInstitutionalInformation, getMenuSorting} from "@/service/dashboard";

export default {
  props: ["btnListValue"],
  data() {
    return {
      originSchoolData: {},
      eventOriginData: {},
      wholeData: [],
      originData: {},
      activeProvince: "选择省份",
      activeSchool: "选择单位",
      originList: {
        北京市: ["清华大学", "北京大学"],
        辽宁省: ["东北大学", "辽宁大学", "沈阳大学"],
        黑龙江省: ["哈尔滨工业大学", "哈尔滨工程大学"]
      },
      provinceBoxShow: false,
      schoolBoxShow: false,
      cityChart: "",
      dataObj: "",
      option: {
        tooltip: {},
        textStyle: {
          color: "#fff", // 高亮时标签颜色变为 白色
          fontSize: 10 // 高亮时标签字体 变大
        },
        geo3D: {
          map: "china", //注册地图的名字
          roam: true, //开启鼠标缩放和平移漫游。默认不开启
          itemStyle: {
            color: "rgba(77, 92, 149, 1)", // 背景颜色
            opacity: 1, //透明度
            borderWidth: 0.4,
            borderColor: "#fff"
          },
          //地图单个板块标签样式
          label: {
            show: false,
            textStyle: { // 字体样式
              color: "#ffffff",
              opacity: 1
            }
          },
          //鼠标放入高亮时地图板块的样式
          emphasis: {
            show: true, // 在鼠标悬浮时显示标签
            label: {
              formatter: (params) => { // 鼠标经过的回调函数
                // console.log('hover', params)
                this.dataObj = params;
                return params.name;
              }
            },
            textStyle: {
              color: "#fff", // 文字颜色设置为白色
              fontSize: 10 // 可以根据需要调整字体大小
            }
          }, //光照阴影
          shading: "lambert",
          light: {
            main: {
              color: "#fff", //光照颜色
              intensity: 1, //光照强度
              shadow: true, //是否显示阴影
              alpha: 69,
              beta: 10
            },
            ambient: {
              intensity: 0.5
            }
          },
          //鼠标控制地图旋转
          viewControl: {
            projection: "perspective", // 投影方式
            autoRotate: false, // 是否开启地图自动旋转
            autoRotateDirection: "cw", // 地图自动旋转的方向
            autoRotateSpeed: 5, // 地图自动旋转的速度
            autoRotateAfterStill: 3, // 鼠标离开后多少秒自动开启旋转
            damping: 0, // 鼠标进行旋转，缩放等操作时延迟时间
            rotateSensitivity: 10, // 旋转操作的灵敏度
            zoomSensitivity: 10, // 缩放操作的灵敏度
            panSensitivity: 10, // 平移操作的灵敏度
            panMouseButton: "left", // 平移操作使用的鼠标按键
            rotateMouseButton: "left", // 旋转操作使用的鼠标按键
            distance: 118, // 默认视角距离主体的距离
            minDistance: 40, // 视角通过鼠标控制能拉近到主体的最小距离
            maxDistance: 145, // 视角通过鼠标控制能拉远到主体的最大距离
            alpha:67, // 视角绕 x 轴，即上下旋转的角度
            beta: 10, // 视角绕 y 轴，即左右旋转的角度
            minAlpha: -70, // 上下旋转的最小 alpha 值
            maxAlpha: 70, // 上下旋转的最大 alpha 值
            minBeta: -70, // 左右旋转的最小 beta 值
            maxBeta: 70, // 左右旋转的最大 beta 值
            center: [6, -18, 0], // 视角中心点
            animation: true, // 是否开启动画
            animationDurationUpdate: 1000, // 过渡动画的时长
            animationEasingUpdate: "cubicInOut" // 过渡动画的缓动效果
          },
          silent: false,
          regionHeight: 2 //修改整个地图的三维高度
        },
        // 3d柱状图实现
        series: [
          {
            name: "bar3D",
            type: "bar3D",
            coordinateSystem: "geo3D",
            barSize: 1, //柱子粗细
            shading: "lambert",
            minHeight: 4,
            opacity: 0.7, // 柱子透明度
            bevelSize: 0.3,
            // 柱子上标签样式
            label: {
              show: true,
              distance: 0, //文字离柱子的距离
              formatter(param) {
                let num = param.data.value[2];

                return param.name + num;
              },
              // 文字样式
              textStyle: {
                color: "#fff",
                fontSize: 16
              }
            },
            emphasis: {//柱子高亮状态的标签和样式配置。
              label: {
                show: false,
                textStyle: {
                  fontSize: 20
                }
              }
            },
            // 柱子样式
            itemStyle: {
              color: "#5397e5",
              opacity: 1
            },
            tooltip: {
              formatter: (params) => {
                return `<div style="text-align: center;">
                      <p>机构名称：${params.name}</p>
                      <p>资产数：${params.value[2]}</p>
                      <p>受影响资产数：${params.value[3]}</p>
                    <div>`;
              }
            },
            data: [
              // {
              //   name: "荣县", //柱子的名字
              //   value: [104.41, 29.45, 1,999]
              // },
              // {
              //   name: "贡井区",
              //   value: [104.63, 29.34, 2,10000]
              // },
              // {
              //   name: "自流井区",
              //   value: [94.69, 38.24, 3,9999]
              // },
              // {
              //   name: "大安区",
              //   value: [84.88, 29.41, 4]
              // },
              // {
              //   name: "东北大学",
              //   value: [123.429096, 41.796767, 5]
              // },
              // {
              //   name: "清华大学",
              //   value: [116.405285, 39.904989, 6]
              // },
            ]
          },
          {
            type: "bar3D",
            coordinateSystem: "geo3D",
            geo3DIndex: 0,
            barSize: 0.5, //柱子粗细
            shading: "lambert",
            minHeight: 1.5,
            opacity: 0.7, // 柱子透明度
            bevelSize: 0.1,
            data: [
              {
                name: 123,
                value: [116.405285, 39.904989,0]
                // pointValue: '98',
                // flag: true
              },
              {
                name: 678,
                value: [123.429096, 41.796767,0]
              }
            ],
            // 这里可以自定义打点的图片
            // symbol: function (value, params) {
            //   const t = params.data.img
            //   return t
            // },
            label: {
              show: true,
              position:"top",
              distance: 1,
              color: "#ecd8be",
              fontSize: 15,
              fontWeight:"700",
              formatter(param) {
                return param.name;
              }
            },
            itemStyle: {
              color: "#d38115",
              opacity: 1
            },
            tooltip: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                formatter: function (params) {
                  const t = params.data.name;

                  return t;
                },
                color: "#fff",
                fontSize: 22
              }
            },
            zLevel: 1
          }
        ]
      }

    };
  },
  computed: {
    provinceList() {
      return ["选择省份", ...Object.keys(this.originList)];
    },
    schoolList() {
      if (this.activeProvince === "选择省份") {
        return ["选择单位"];
      }
      if (Array.isArray(this.originList[this.activeProvince])){
        return ["选择单位", ...this.originList[this.activeProvince]];
      }
      return ["选择单位", this.originList[this.activeProvince]];
    }
  },
  mounted() {
    this.getData();
    // this.initMap();
    this.getCityMap();
  },
  watch: {
    btnListValue(val) {
      if (this.activeProvince === "选择省份") {
        this.drawEventMap(val);
      } else {
        if (this.originData[this.activeProvince]) {
          const arr = this.originData[this.activeProvince].map(item => {
            const data = this.originSchoolData[item][this.btnListValue];

            return {
              name: item.ent,
              value: [item.lon, item.lan, data.asset_num,  data.asset_vul]
            };
          });

          this.option.series[0].data = arr;
        } else {
          this.option.series[0].data = [];
        }
        this.cityChart.setOption(this.option);
      }
    }
  },
  methods: {
    changeProvince(name) {
      this.activeProvince = name;
      this.provinceBoxShow = false;
      this.activeSchool = "选择单位";
      if (this.activeProvince === "选择省份") {
        this.fnGoDown("china");
      } else {
        this.fnGoDown(this.activeProvince);
      }
    },
    changeSchool(name) {
      this.activeSchool = name;
      this.schoolBoxShow = false;
      if (name === "选择单位") {
        this.fnGoDown(this.activeProvince);
      } else {
        const provinceObj = this.originData[this.activeProvince];

        let data = {};

        if (Array.isArray(provinceObj)) {
          data = provinceObj.find(item => item.ent === name);
        } else {
          data = provinceObj;
        }
        const obj = this.originSchoolData[name];

        this.option.series[0].data = [{name, value: [data.lon, data.lan, obj.asset_num,  obj.asset_vul]}];
        this.cityChart.setOption(this.option);
      }
    },
    getData(){
      // getInstitutionalInformation();
      // getAlarmTiming();
      this.getMenu();
      this.getSchoolInfo();
      this.getVulSum();
    },
    getMenu() {
      getMenuSorting().then(res => {
        this.originList = res;
      });
    },
    getVulSum() {
      getAlarmTiming().then(res => {
        this.eventOriginData = res;
        this.drawEventMap("all");
      });
    },
    drawEventMap(type) {
      const typeData = this.eventOriginData[type];

      if (typeData) {
        this.option.series[1].data = typeData.map(item => {
          return {
            name: item.count,
            value: [item.lon,item.lat,0]
          };
        });
      } else {
        this.option.series[1].data = [];
      }
      if (!this.cityChart) {
        this.cityChart = this.$echarts.init(this.$refs.cityMap);
        this.$echarts.registerMap("china", china);
        this.cityChart.getZr().on("dblclick", () => {
          this.fnGoDown(this.dataObj.name);
        });

      }
      this.cityChart.setOption(this.option);
    },
    getSchoolInfo() {
      Promise.all([getAssetCorrelationMap(),getInstitutionalInformation()]).then(res => {
        this.originData = res[0];
        this.originSchoolData = res[1];
        // const arr = [];
        // Object.keys(res).forEach(item => {
        //     res[item].forEach(items => {
        //         arr.push({
        //             name: items.ent,
        //             value: [items.lon,items.lan, 10]
        //         })
        //     })
        // });
        // this.option.series[0].data = arr;
      });

    },
    // 地图
    getCityMap() {
      this.cityChart = this.$echarts.init(this.$refs.cityMap);
      this.$echarts.registerMap("china", china);
      // let option = {
      //   tooltip: {},
      //   textStyle: {
      //     color: '#fff', // 高亮时标签颜色变为 白色
      //     fontSize: 10, // 高亮时标签字体 变大
      //   },
      //   geo3D: {
      //     map: "china", //注册地图的名字
      //     roam: true, //开启鼠标缩放和平移漫游。默认不开启
      //     itemStyle: {
      //       color: "rgba(77, 92, 149, 1)", // 背景颜色
      //       opacity: 1, //透明度
      //       borderWidth: 0.4,
      //       borderColor: "#fff",
      //     },
      //     //地图单个板块标签样式
      //     label: {
      //       show: false,
      //       textStyle: { // 字体样式
      //         color: '#ffffff',
      //         opacity: 1,
      //       },
      //     },
      //     //鼠标放入高亮时地图板块的样式
      //     emphasis: {
      //       show: true, // 在鼠标悬浮时显示标签
      //         label: {
      //             formatter: (params) => { // 鼠标经过的回调函数
      //                 // console.log('hover', params)
      //                 dataObj = params;
      //                 return params.name
      //             },
      //         },
      //       textStyle: {
      //         color: '#fff', // 文字颜色设置为白色
      //         fontSize: 10, // 可以根据需要调整字体大小
      //       },
      //     },
      //     // 每个地图板块单独设置背景颜色
      //     // regions: [
      //     //   {
      //     //     name: '四川省',
      //     //     itemStyle: {
      //     //       color: '#5064F7'
      //     //     }
      //     //   },
      //     //   {
      //     //     name: '天津省',
      //     //     itemStyle: {
      //     //       color: '#9E64F7'
      //     //     }
      //     //   },
      //     //   {
      //     //     name: '北京市',
      //     //     itemStyle: {
      //     //       color: '#5A64F1'
      //     //     }
      //     //   },
      //     //   {
      //     //     name: '辽宁省',
      //     //     itemStyle: {
      //     //       color: '#b2e3ad'
      //     //     }
      //     //   },
      //     //   {
      //     //     name: '河南省',
      //     //     itemStyle: {
      //     //       color: '#DE0000'
      //     //     }
      //     //   },
      //     //   {
      //     //     name: '山东省',
      //     //     itemStyle: {
      //     //       color: '#F5C25F'
      //     //     }
      //     //   },
      //     //   {
      //     //     name: '甘肃省',
      //     //     itemStyle: {
      //     //       color: '#228AA0'
      //     //     }
      //     //   },
      //     // ],
      //     //光照阴影
      //     shading: "lambert",
      //     light: {
      //       main: {
      //         color: "#fff", //光照颜色
      //         intensity: 1, //光照强度
      //         shadow: true, //是否显示阴影
      //         alpha: 60,
      //         beta: 10,
      //       },
      //       ambient: {
      //         intensity: 0.3,
      //       },
      //     },
      //     //鼠标控制地图旋转
      //     viewControl: {
      //       projection: "perspective", // 投影方式
      //       autoRotate: false, // 是否开启地图自动旋转
      //       autoRotateDirection: "cw", // 地图自动旋转的方向
      //       autoRotateSpeed: 5, // 地图自动旋转的速度
      //       autoRotateAfterStill: 3, // 鼠标离开后多少秒自动开启旋转
      //       damping: 0, // 鼠标进行旋转，缩放等操作时延迟时间
      //       rotateSensitivity: 10, // 旋转操作的灵敏度
      //       zoomSensitivity: 10, // 缩放操作的灵敏度
      //       panSensitivity: 10, // 平移操作的灵敏度
      //       panMouseButton: "left", // 平移操作使用的鼠标按键
      //       rotateMouseButton: "left", // 旋转操作使用的鼠标按键
      //       distance: 118, // 默认视角距离主体的距离
      //       minDistance: 40, // 视角通过鼠标控制能拉近到主体的最小距离
      //       maxDistance: 145, // 视角通过鼠标控制能拉远到主体的最大距离
      //       alpha: 50, // 视角绕 x 轴，即上下旋转的角度
      //       beta: 15, // 视角绕 y 轴，即左右旋转的角度
      //       minAlpha: -70, // 上下旋转的最小 alpha 值
      //       maxAlpha: 70, // 上下旋转的最大 alpha 值
      //       minBeta: -70, // 左右旋转的最小 beta 值
      //       maxBeta: 70, // 左右旋转的最大 beta 值
      //       center: [6, -18, 0], // 视角中心点
      //       animation: true, // 是否开启动画
      //       animationDurationUpdate: 1000, // 过渡动画的时长
      //       animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果
      //     },
      //     silent: false,
      //     regionHeight: 2, //修改整个地图的三维高度
      //   },
      //   // 3d柱状图实现
      //   series: [
      //     {
      //       name: 'bar3D',
      //       type: 'bar3D',
      //       coordinateSystem: 'geo3D',
      //       barSize: 1, //柱子粗细
      //       shading: 'lambert',
      //       opacity: .7, // 柱子透明度
      //       bevelSize: 0.1,
      //       // 柱子上标签样式
      //       label: {
      //         show: true,
      //         distance: 0, //文字离柱子的距离
      //         formatter(param) {
      //           let num = param.data.value[2]
      //           return param.name + num;
      //         },
      //         // 文字样式
      //         textStyle: {
      //           color: '#fff',
      //           fontSize: 16,
      //         }
      //       },
      //       emphasis: {//柱子高亮状态的标签和样式配置。
      //         label: {
      //           show: false,
      //           textStyle: {
      //             fontSize: 20,
      //           }
      //         }
      //       },
      //       // 柱子样式
      //       itemStyle: {
      //         color: '#5397e5',
      //         opacity: 1
      //       },
      //       data: [
      //         {
      //           name: "荣县", //柱子的名字
      //           value: [104.41, 29.45, 1] //柱子显示在地图的位置（经纬度），柱子的值
      //         },
      //         {
      //           name: "贡井区",
      //           value: [104.63, 29.34, 2]
      //         },
      //         {
      //           name: "自流井区",
      //           value: [94.69, 38.24, 3]
      //         },
      //         {
      //           name: "大安区",
      //           value: [84.88, 29.41, 4]
      //         },
      //         {
      //           name: "东北大学",
      //           value: [123.429096, 41.796767, 5]
      //         },
      //         {
      //           name: "清华大学",
      //           value: [116.405285, 39.904989, 6]
      //         },
      //       ]
      //     }
      //   ],
      // }
      this.cityChart.getZr().on("dblclick", (params) => {
        // if (params.componentSubType === 'map') {
        //     // 下钻事件进行下钻
        this.fnGoDown(this.dataObj.name);
        // }
      });
      this.cityChart.setOption(this.option);
    },
    fnGoDown(name) {
      console.log("_fnGoDown_", name);
      // 先判断可不可以下钻
      if (name !== "china") {
        this.activeProvince = name;
      }
      const mapname = name === ("中国" || "china") ? "china" : name;

      this.nowDomainName = mapname;
      if (mapname === "china") {
        this.$echarts.registerMap(mapname, china);
        // this.options.geo.zoom = 1.2;
        // this.options.series[0].zoom = 1.2;
        // this.options.geo.center = null;
        // this.options.series[0].center = null;
        this.option.geo3D.map = mapname;
        this.option.series[0].map = mapname;
        this.option.series[0].data = [];
        const typeData = this.eventOriginData[this.btnListValue];

        if (typeData) {
          this.option.series[1].data = typeData.map(item => {
            return {
              name: item.count,
              value: [item.lon,item.lat,0]
            };
          });
        } else {
          this.option.series[1].data = [];
        }
        this.cityChart.dispose();
        this.$nextTick(() => {
          this.cityChart = this.$echarts.init(this.$refs.cityMap);
          this.cityChart.getZr().on("dblclick", () => {
            this.fnGoDown(this.dataObj.name);
          });

          this.cityChart.setOption(this.option);
        });
      } else {
        // 下钻省
        // eslint-disable-next-line no-lonely-if
        // if (this.currentLevel === 0) {
        // 寻找省id
        import("./chinaProvince.json").then((provinceData) => {
          provinceData.features.forEach((element) => {
            if (element.properties.fullname === name) {
              // 获取省id
              const provinceId = element.properties.id;

              import(
                `./geometryProvince/${provinceId}.json`
              ).then((res) => {
                // 清除打点与连线数据
                this.option.series[1].data = [];
                // console.log(this.originData[name]);
                if (this.originData[name]) {
                  if (Array.isArray(this.originData[name])) {
                    const arr = this.originData[name].map(item => {
                      const data = this.originSchoolData[item.ent];

                      return {
                        name: item.ent,
                        value: [item.lon, item.lan, data.asset_num,  data.asset_vul]
                      };
                    });

                    this.option.series[0].data = arr;
                  } else {
                    const data = this.originSchoolData[this.originData[name].ent];

                    this.option.series[0].data = [{
                      name: this.originData[name].ent,
                      value: [this.originData[name].lon,this.originData[name].lan, data.asset_num,  data.asset_vul]
                    }];
                  }
                } else {
                  this.option.series[0].data = [];
                }
                // this.options.geo.zoom = 1.2;
                // this.options.series[0].zoom = 1.2;
                // this.options.geo.center = null;
                // this.options.series[0].center = null;
                // this.options.series[2].data = [];
                // 将options中数据替换掉，并刷新
                const newMapJson = res.default;

                this.option.geo3D.map = mapname;
                this.option.series[0].map = mapname;
                this.$echarts.registerMap(mapname, newMapJson);
                this.cityChart.dispose();
                this.$nextTick(() => {
                  this.cityChart = this.$echarts.init(this.$refs.cityMap);
                  this.cityChart.setOption(this.option);
                });
              });
            }
          });
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.mapData {
  font-family: AlibabaRegular;
  position: absolute;
  left: 500px;
  top: 276px;
  width: 919px;
  height: 656px;
}
.box-expand {
    height: 800px;
}
.option-box {
    box-sizing: border-box;
    display: flex;
    position: absolute;
    left: 32px;
    top: -49px;
    z-index: 8;
    height: 49px;
    border-radius: 10px;
    background: linear-gradient(270deg, rgba(113, 125, 219, 0.72) 2.27%, rgba(75, 90, 201, 0.8) 100%);
    box-shadow: 1px 1px 4.5px 0px #00000040;
    padding-left: 20px;
    padding-right: 20px;
    align-items: center;
    color: #FFF;
    .left-option {
        display: flex;
        align-items: center;
        position: relative;
        height: 100%;
    }
    .left-option:hover .province-box{
      display: block;
    }
    .right-option {
        display: flex;
        align-items: center;
        position: relative;
        height: 100%;
    }
    .right-option:hover .school-box{
      display: block;
    }
    .split-line {
        height: 23px;
        border-left: 1px solid #9392A0;
        width: 20px;
        margin-left: 20px;
    }
    .arrow-down {
        width: 20px;
        height: 12px;
        margin-left: 20px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .checkedItem{
      background: linear-gradient(to right,rgba(143, 147, 183, 0.9),rgba(63, 65, 81, 0.5));
    }
    .province-box {
        width: 135px;
        max-height: 188px;
        display: none;
        overflow-y: scroll;
        box-sizing: border-box;
        background-color: #53546BB2;
        position: absolute;
        right: -20px;
        top:100%;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        .province-item {
          box-sizing: border-box;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
        }
        .province-item:hover{
          background: linear-gradient(to right,rgba(143, 147, 183, 0.9),rgba(63, 65, 81, 0.5));
        }

    }
    .school-box {
        width: 135px;
        box-sizing: border-box;
        background-color: #53546BB2;
        position: absolute;
        display: none;
        max-height: 188px;
        overflow-y: scroll;
        left: -20px;
        overflow-x: hidden; /* 隐藏水平滚动条 */
        top:100%;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        .school-item {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          span{
            //width: 135px;
            white-space: nowrap; /* 确保文本在一行内显示 */
            overflow: hidden; /* 隐藏超出容器的内容 */
            text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
          }
        }
        .school-item:hover{
          background: linear-gradient(to right,rgba(143, 147, 183, 0.9),rgba(63, 65, 81, 0.5));
        }
    }


  .text {
        min-width: 63px;
        font-family: AlibabaRegular;
        font-size: 16px;
    }
}

// 水平方向滚动条
.province-box::-webkit-scrollbar {
  //修改滚动条宽度或高度
  width: 7px;
  margin-right: 3px ;
}
.province-box::-webkit-scrollbar-thumb {
  //border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  background: linear-gradient(#949EE8,#8F9AF4);
  border: 1px solid transparent;
  border-image:linear-gradient(rgb(255, 255, 255), rgba(255,255,255,0.1)) 1;
}
.province-box::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  //background: rgba(241, 237, 255, 1);
}
.school-box::-webkit-scrollbar {
  //修改滚动条宽度或高度
  width: 7px;
  //border-radius: 8px;
}
.school-box::-webkit-scrollbar-thumb {
  //border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  background: linear-gradient(#949EE8,#8F9AF4);
  border: 1px solid transparent;
  border-image:linear-gradient(rgb(255, 255, 255), rgba(255,255,255,0.1)) 1;
}
.school-box::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  //background: rgba(241, 237, 255, 1);
}

</style>
